import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import type { Locale } from '@/shared/api/types';
import { LOCALE_LABELS, changeLocale } from '@/shared/i18n';
import { useTelegram } from '@/shared/hooks/useTelegram';
import { Sheet } from '../Sheet/Sheet';
import { ListRow } from '../ListRow/ListRow';
import { GlobeIcon } from '../lib/icons';
import styles from './LanguageSwitch.module.css';

export function LanguageSwitch(): React.ReactElement {
  const { t, i18n } = useTranslation();
  const { haptic } = useTelegram();
  const [isOpen, setIsOpen] = useState(false);

  const handleSelect = async (locale: Locale): Promise<void> => {
    haptic('selection');
    setIsOpen(false);
    await changeLocale(locale);
  };

  const currentLocale = i18n.language as Locale;

  return (
    <>
      <button
        type="button"
        className={styles.trigger}
        onClick={() => {
          haptic('light');
          setIsOpen(true);
        }}
        aria-label={t('profile.language')}
        title={currentLocale.toUpperCase()}
      >
        <GlobeIcon size={20} />
      </button>

      <Sheet open={isOpen} onClose={() => setIsOpen(false)} title={t('profile.language')}>
        <div className={styles.list}>
          {Object.entries(LOCALE_LABELS).map(([locale, label]) => (
            <ListRow
              key={locale}
              title={label}
              onClick={() => handleSelect(locale as Locale)}
              value={currentLocale === locale ? '✓' : ''}
            />
          ))}
        </div>
      </Sheet>
    </>
  );
}
